import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export const formPageNameFieldRowClassName =
    "flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-border py-4";

export const formPageNameLabelClassName =
    "m-0 shrink-0 font-['Roboto',sans-serif] text-base font-medium leading-snug text-foreground";

export const formPageNameInputClassName =
    "block h-[calc(2.125rem+2px)] min-h-[calc(2.125rem+2px)] !w-[250px] max-w-full shrink-0 px-2 py-[0.4375rem] text-left text-[0.8125rem] leading-5";

type FormPageNameFieldProps = {
    label: string;
    labelId?: string;
    inputId: string;
    value: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    readOnly?: boolean;
    autoFocus?: boolean;
};

export function FormPageNameField({
    label,
    labelId,
    inputId,
    value,
    onChange,
    disabled,
    readOnly,
    autoFocus,
}: FormPageNameFieldProps) {
    return (
        <div className={formPageNameFieldRowClassName}>
            <h5 className={formPageNameLabelClassName} id={labelId}>
                {label}
            </h5>
            <Input
                id={inputId}
                className={formPageNameInputClassName}
                value={value}
                onChange={onChange}
                disabled={disabled}
                readOnly={readOnly}
                autoFocus={autoFocus}
            />
        </div>
    );
}

export function FormPageNameFieldSkeleton() {
    return (
        <div className={formPageNameFieldRowClassName} aria-hidden>
            <Skeleton className="h-4 w-20 shrink-0 rounded-[4px]" />
            <Skeleton className={cn(formPageNameInputClassName, "rounded-[4px]")} />
        </div>
    );
}
